export function isNoiseDisabledByID(state, deviceId) {
    const { audioDeviceIDs = {} } = state['wildix/customStorageSettings'];
    return typeof audioDeviceIDs[deviceId] === 'undefined' ? true : audioDeviceIDs[deviceId];
}
// Map to track if video was fixed for each visitor status
const isVideoWasFixed = new Map();
/**
 * Checks if a video track is in a stuck state where the JitsiTrack and underlying track
 * have mismatched mute states
 * @param jitsiTrack - The JitsiTrack to check
 * @returns boolean indicating if the track is stuck
 */
function isVideoTrackStuck(jitsiTrack) {
    return jitsiTrack?.muted === false && jitsiTrack?.track?.muted === true;
}
/**
 * Fixes video screen sharing by temporarily stopping and resuming video transmission
 * This helps resolve issues where the video track gets stuck in an inconsistent state
 * @param jitsiTrack - The JitsiTrack to fix
 * @param isVisitor - Whether the current user is a visitor
 */
export function fixVideoScreenSharing(jitsiTrack, isVisitor) {
    const visitorKey = isVisitor ? 'visitor' : 'participant';
    const isVideoFixed = isVideoWasFixed.get(visitorKey);
    console.warn(`WILDIX-23019: isVideoWasFixed by visitorKey: ${isVideoFixed}`);
    if (isVideoFixed) {
        return;
    }
    if (isVideoTrackStuck(jitsiTrack)) {
        const conference = jitsiTrack?.conference;
        if (!conference) {
            return;
        }
        // First command: stop sending video
        conference.setLastN(0);
        // Wait for SFU to process and tear down stream
        setTimeout(() => {
            // Second command: resume sending all video
            conference.setLastN(-1);
            console.warn(`WILDIX-23019: LastN restored for user: ${visitorKey} is 1000ms`);
        }, 1000); // 1000ms is the optimal delay
        isVideoWasFixed.set(visitorKey, true);
    }
}
